<div (click)="logoutClick()" class="menu_item" [style.color]="color">
    <div class="menu-icon opacity-1">
        <span class="material-symbols-outlined font-20">
            {{icon_name}}
        </span>
    </div>
    <label class="menu-label opacity-1 font-17" [style.color]="color">{{title}}</label>
</div>